import { defaultCacheableSingleton } from '@/lib/cacheable';
import { hygraphClient } from '@/lib/graphql-clients';
import { DisciplineType, getSdk, Maybe } from '@/lib/types';
import { Discipline, Specialty } from '@/lib/types';

const getByDiscipline = async (discipline: Maybe<Discipline> | undefined) => {
  return defaultCacheableSingleton.remember(
    `specialties-${discipline?.id}`,
    async () => {
      const sdk = getSdk(hygraphClient());
      const { specialties } = await sdk.Specialties({
        where: { discipline },
      });

      return specialties as Specialty[];
    }
  );
};

const getByDisciplineType = async (
  disciplineType: Maybe<DisciplineType> | undefined
) => {
  return defaultCacheableSingleton.remember(
    `specialties-${disciplineType}`,
    async () => {
      const sdk = getSdk(hygraphClient());
      const { specialties } = await sdk.Specialties({
        where: { discipline: { disciplineType } },
      });

      return specialties as Specialty[];
    }
  );
};

const SpecialtiesService = {
  getByDiscipline,
  getByDisciplineType,
};

export default SpecialtiesService;
